import noop from '../utils/noop'
import shallowEqual from 'fbjs/lib/shallowEqual'
import defaults from 'lodash/defaults'
import forEach from 'lodash/forEach'
import isFunction from 'lodash/isFunction'
import classNames from 'classnames'
import PropTypes from 'prop-types'
import React, { Component } from 'react'

export default class Video extends Component {
  static propTypes = {
    alwaysShowControls: PropTypes.bool,
    captionSource: PropTypes.string,
    controlBar: PropTypes.object,
    height: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    listeners: PropTypes.object,
    onReady: PropTypes.func,
    options: PropTypes.object,
    plugins: PropTypes.object,
    src: PropTypes.shape({
      hd: PropTypes.string,
      sd: PropTypes.string
    }).isRequired,
    width: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
  }

  static defaultProps = {
    alwaysShowControls: false,
    onReady: noop
  }

  constructor(props) {
    super(props)

    this.updatePlugin = this.updatePlugin.bind(this)
  }

  componentDidMount() {
    const { onReady, listeners } = this.props

    this.player = window.videojs(this.videoEl, this.getOptions())
    this.player.ready(onReady)

    this.videoEl.addEventListener(
      'contextmenu',
      e => {
        e.preventDefault()
      },
      false
    )

    forEach(listeners, (fn, name) => this.player.on(name, fn))
  }

  componentWillReceiveProps(nextProps) {
    const { plugins, src, options, listeners } = nextProps

    if (plugins) {
      forEach(plugins, this.updatePlugin)
    }
    if (src && !shallowEqual(src, this.props.src)) {
      this.updateSrc(src)
    }
    if (options && !shallowEqual(options, this.props.options)) {
      this.updateOptions(options)
    }
    if (listeners && !shallowEqual(listeners, this.props.listeners)) {
      this.updateListeners(listeners)
    }
    if (options && options.autoplay != null) {
      this.player.autoplay(options.autoplay)
    }
  }

  shouldComponentUpdate() {
    return false
  }

  componentWillUnmount() {
    this.player.off()
    this.player.pause()

    try {
      this.player.dispose()
    } catch (e) {
      if (process.env.NODE_ENV !== 'production') {
        console.log('player disposed with error ' + e)
      }
    }
  }

  getValue(name) {
    const value = this.player[name]
    return isFunction(value) ? value.call(this.player) : value
  }

  currentTime(seconds) {
    return this.player.currentTime(seconds)
  }

  play() {
    this.player.play()
  }

  pause() {
    this.player.pause()
  }

  updatePlugin(options, name) {
    if (!shallowEqual(this.props.plugins[name], options)) {
      this.player[name](options)
    }
  }

  updateSrc(src) {
    this.player.quality(src)
  }

  updateOptions(options) {
    this.player.options(options)
  }

  updateListeners(listeners) {
    forEach(listeners, (fn, name) => {
      if (this.props.listeners != null && this.props.listeners[name] !== fn) {
        if (this.props.listeners != null && this.props.listeners[name]) {
          this.player.off(name, this.props.listeners[name])
        }
        this.player.on(name, fn)
      }
    })
  }

  getControls() {
    const { controlBar } = this.props

    if (!controlBar) {
      return {}
    }

    return {
      controlBar: {
        children: controlBar
      }
    }
  }

  getPlugins() {
    return Object.assign({}, this.props.plugins, {
      quality: this.props.src
    })
  }

  getOptions() {
    return defaults(
      {},
      this.props.options,
      {
        controls: true,
        preload: 'metadata',
        plugins: this.getPlugins()
      },
      this.getControls()
    )
  }

  getVideoRestrictedMessage() {
    return (
      <div className="vjs-qualvu-skin vjs-video-restricted-overlay">
        <div className="vjs-qualvu-skin vjs-video-restricted-overlay-title">
          <div className="vjs-qualvu-skin vjs-video-restricted-icon" />
          <h3>Video disabled</h3>
        </div>
        <p>
          Due to security regulations this video has been disabled.
          <br />
          Only the audio track is currently available.
        </p>
      </div>
    )
  }

  addClosedCaption() {
    if (this.props.captionSource) {
      return (
        <track
          default={true}
          kind="captions"
          label="English"
          src={this.props.captionSource}
          srcLang="en"
        />
      )
    }
  }

  audioMode() {
    return /\.mp3($|\?)/.test(this.props.src.sd)
  }

  render() {
    const { alwaysShowControls, height, width } = this.props
    const classes = classNames('video-js', 'vjs-qualvu-skin', {
      'vjs-controls-always': alwaysShowControls,
      'vjs-video-restricted': this.audioMode()
    })

    return (
      <div style={{ height, position: 'relative' }}>
        <video
          ref={ref => (this.videoEl = ref)}
          className={classes}
          width={width}
          height={height}
          crossOrigin={'anonymous'}
        >
          <source type={this.audioMode() ? 'audio/mp3' : 'video/mp4'} />
          {this.addClosedCaption()}
        </video>
        {this.audioMode() && this.getVideoRestrictedMessage()}
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ../src/components/Video.js